import React, { PropsWithChildren } from "react";
import * as styles from "./IntroText.module.scss";
import clsx from "clsx";
import MultiLine from "components/Text/MultiLine";

type Props = {
  className?: string;
};

const IntroText: React.FC<PropsWithChildren<Props>> = ({
  className,
  children
}) => {
  return (
    <div className={clsx(styles.introText, className)}>
      <MultiLine>{children}</MultiLine>
    </div>
  );
};

export default IntroText;
